// Sentry initialization should be imported first!
import './instrument'
import { ErrorBoundary } from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { Init } from './components/Init/Init'
import * as serviceWorker from './serviceWorker'
import CasinoLayoutSkeleton from './components/Casino/CasinoLayoutSkeleton'
import defineCustomElements from './customElements'
import { ErrorFallback } from './components/ErrorFallback/ErrorFallback'
import { errorFallbackComponentsName } from './components/ErrorFallback/errorFallbackConstants'

// Import conflicting CSS files in root to avoid build issues with mini-css-extract-plugin.
import './components/Casino/Casino.scss'
import './components/Footer/FooterPage.scss'
import './components/GameCabinet/GameBlockedModal.scss'
import './components/GameCabinet/GameCabinet.scss'
import './components/Leaderboard/Leaderboard.scss'
import './components/Leaderboard/LeaderboardTable.scss'
import './components/H5Modal/H5Modal.scss'
import './components/Leaderboard/LeaderboardButton.scss'
import './components/NotFound/NotFound.scss'
import './components/SweepstakesRules/SweepstakesRules.scss'
import './components/TopBar/styles/topBar.scss'
import './components/TopBar/TopBarLogo/styles/topBarLogo.scss'
import './sweepstakes/InsufficientFunds/InsufficientFunds.scss'
import './sweepstakes/SweepsBoostOverlay/SweepsBoostOverlay.scss'
import './sweepstakes/SweepsClaimCenter/SweepsClaimCenter.scss'
import './sweepstakes/SweepsClaimCenter/SweepsClaimCenterContents.scss'
import './sweepstakes/SweepsClaimCenter/SweepsClaimCenterInbox/SweepsClaimCenterInboxMessage.scss'
import './sweepstakes/SweepsLegalDocsPopup/SweepsLegalDocsPopup.scss'
import './sweepstakes/SweepsPlayerInfoModal/styles/sweepsPlayerInfo.scss'
import './sweepstakes/SweepsRealityCheckPopup/SweepsRealityCheckPopup.scss'
import './sweepstakes/SweepsTopBar/SweepsTopBar.scss'
import './sweepstakes/SweepsWallet/SweepsWallet.scss'
import './sweepstakes/SweepsWalletDropdown/SweepsWalletDropdown.scss'
import './sweepstakes/SweepsWalletToggle/SweepsWalletToggle.scss'

defineCustomElements()

const isLoading = window.location.pathname.indexOf('/loading') === 0

const root = createRoot(document.getElementById('root'))

root.render(
  isLoading ? (
    <CasinoLayoutSkeleton />
  ) : (
    <ErrorBoundary
      beforeCapture={scope => {
        scope.setTag('Application', 'Init')
      }}
      fallback={fallbackData => <ErrorFallback {...fallbackData} componentName={errorFallbackComponentsName.init} />}
    >
      <Init />
    </ErrorBoundary>
  )
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
